/**
 * External dependencies
 */
import React, { useState } from 'react';
import { Text, Box } from '@towersystems/towersystems-design-system';
import { noop } from 'lodash';
import { confirmAlert } from 'react-confirm-alert';

/**
 * Internal dependencies
 */
import PaymentMethodIcon from 'components/payment-method-icon';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import Tag from 'components/tag';
import Icon from 'components/icon';
import ConfirmRemovePaymentMethodDialog from './confirm-remove-payment-method-dialog';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css';

const PaymentMethodListItem = ({
    type,
    id,
    removeItem = noop,
    afterRemoveItem = noop,
    afterSuccessRemoveItem = noop,
    title,
    description,
    primary,
    beforeActions,
}) => {
    const [requesting, setRequesting] = useState(false);

    const handleRemoveItem = async () => {
        try {
            setRequesting(true);
            await removeItem(id);
            afterSuccessRemoveItem(id);
        } catch (error) {
            console.log('handleRemoveItem', error);
        }
        setRequesting(false);
        afterRemoveItem(id);
    };

    const handleClickRemove = () => {
        confirmAlert({
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmRemovePaymentMethodDialog onClose={onClose} onSubmit={handleRemoveItem} />
            ),
        });
    };

    const disabled = requesting;

    return (
        <Box
            className='payment-method__list-item'
            paddingTop='large'
            paddingBottom='large'
            display='flex'
            alignItems='center'
            justifyContent='spaceBetween'
        >
            <Box>
                <Box display='flex' alignItems='center'>
                    <PaymentMethodIcon type={type} />
                    <Box alignItems='left' display='flex' flexDirection='column'>
                        <Text size='small' weight='medium'>
                            {title}
                        </Text>
                        {description && <Text size='small'>{description}</Text>}
                    </Box>
                    {primary && (
                        <Box marginLeft='large'>
                            <Tag compact success>primary</Tag>
                        </Box>
                    )}
                </Box>
            </Box>
            <Box display='flex'>
                {beforeActions}
                <ButtonGroup dividers>
                    <Button className='payment-methods-list__remove-method-btn' onClick={handleClickRemove} text compact>
                        <Icon name='FiX' type='fi' />
                    </Button>
                </ButtonGroup>
            </Box>
        </Box>
    );
};

export default PaymentMethodListItem;
